import Cookies from 'js-cookie'
const expireDay = 365
const pathName = ''

const TokenKey = 'passport'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: expireDay, path: pathName })
}

export function removeToken() {
  return Cookies.remove(TokenKey, { path: pathName })
}

const WechatKey = 'bhjWechatID'

export function getOpenId() {
  return Cookies.get(WechatKey)
}

export function setOpenId(openId) {
  return Cookies.set(WechatKey, openId, { expires: expireDay, path: pathName })
}

export function removeOpenId() {
  return Cookies.remove(WechatKey, { path: pathName })
}

const userKey = 'user'

export function getUserInfo() {
  return JSON.parse(Cookies.get(userKey) || null)
}

export function setUserInfo(val) {
  const data = {
    id: val.id,
    nickName: val.nickName,
    trueName: val.trueName,
    mobile: val.mobile,
    avatar: val.avatar,
    hasCertificate: val.hasCertificate
  }
  return Cookies.set(userKey, data, { expires: expireDay, path: pathName })
}

export function removeUserInfo() {
  return Cookies.remove(userKey, { path: pathName })
}

const wxKey = 'wxInfo'

export function getWXInfo() {
  return JSON.parse(Cookies.get(wxKey) || null)
}

export function setWXInfo(val) {
  return Cookies.set(wxKey, val, { expires: expireDay, path: pathName })
}

export function removeWXInfo() {
  return Cookies.remove(wxKey, { path: pathName })
}

const regKey = 'register'

export function getRegisterInfo() {
  return JSON.parse(Cookies.get(regKey) || null)
}

export function setRegisterInfo(data) {
  return Cookies.set(regKey, data, { expires: expireDay, path: pathName })
}

export function removeRegisterInfo() {
  return Cookies.remove(regKey, { path: pathName })
}

const memberKey = 'membership'

export function getMembership() {
  const str = Cookies.get(memberKey)
  let ret = null
  if(str && str != 'undefined') {
    ret = JSON.parse(Cookies.get(memberKey) || null)
  }
  return ret
}

export function setMembership(data) {
  return Cookies.set(memberKey, data, { expires: expireDay, path: pathName })
}

export function removeMembership() {
  return Cookies.remove(memberKey, { path: pathName })
}

const memberTypeKey = 'memberType'

export function getMemberType() {
  return JSON.parse(Cookies.get(memberTypeKey) || null)
}

export function setMemberType(data) {
  return Cookies.set(memberTypeKey, data, { expires: expireDay, path: pathName })
}

export function removeMemberType() {
  return Cookies.remove(memberTypeKey, { path: pathName })
}



// WEBPACK FOOTER //
// ./src/libs/cookie-storage.js